/**
 * Created by zhaoyao on 19:45.
 * 亲情号码
 */
import React from 'react';
import {Icon, Divider, Button} from "antd";
import {fetchGet, fetchPost} from "../../utils/fetchRequest";
import {API} from "../../configs/api.config";
import  {Toast } from "antd-mobile";

class AffectionPhone extends React.Component{
    constructor(props){
        super(props);
        this.state={
            name:'RechargeDetail',
            data:{

            },
            IMEI: this.props.match.params.IMEI,
            relation: null,
            phone: null,
            relation1: null,
            phone1: null,
            relation2: null,
            phone2: null,
        };
    }


    componentDidMount(){
        Toast.loading('努力加载中...', 0)
        this.getAffection()
    }

    render(){
        const {relation, phone, relation1, phone1, relation2, phone2} = this.state
        return <div className="padding_15" onChange={this.nicknameValueCom}>
        亲情号1/2/3分别对应学生卡上的1/2/3号按键，当分别按下后，学生卡会给对应的手机号拨打电话
                <div className="item_sty">
                    <div className="left_title">关系</div>
                    <input ref='relation' className="text-right right_input" type="text" placeholder="请输入" maxLength={20} autoFocus="autoFocus" value={this.state.relation}/>
                </div>
                <div className="item_sty">
                    <div className="left_title">号码1</div>
                    <input ref='phone' className="text-right right_input" type="text" placeholder="请输入" maxLength={20} autoFocus="autoFocus" value={this.state.phone}/>
                </div>
                <div className="comhline_sty1"></div>
                <div className="item_sty">
                    <div className="left_title">关系</div>
                    <input ref='relation1' className="text-right right_input" type="text" placeholder="请输入" maxLength={20} autoFocus="autoFocus" value={this.state.relation1}/>
                </div>
                <div className="item_sty">
                    <div className="left_title">号码2</div>
                    <input ref='phone1' className="text-right right_input" type="text" placeholder="请输入" maxLength={20} autoFocus="autoFocus" value={this.state.phone1}/>
                </div>
                <div className="comhline_sty1"></div>
                <div className="item_sty">
                    <div className="left_title">关系</div>
                    <input ref='relation2' className="text-right right_input" type="text" placeholder="请输入" maxLength={20} autoFocus="autoFocus" value={this.state.relation2}/>
                </div>
                <div className="item_sty">
                    <div className="left_title">号码3</div>
                    <input ref='phone2' className="text-right right_input" type="text" placeholder="请输入" maxLength={20} autoFocus="autoFocus" value={this.state.phone2}/>
                </div>
                <div className="comhline_sty1"></div>
            <Button type="primary" block className='commonButton' style={{marginTop: '35px',borderRadius: '30px',}}
                                    onClick={this.bindAffection}>保存</Button>
        </div>
    }

    bindAffection = () => {
        Toast.loading('保存中...')
        const {IMEI, relation, phone, relation1, phone1, relation2, phone2} = this.state

        const paramObj = {
            IMEI: IMEI,
            relation: relation,
            phone: phone,
            relation1: relation1,
            phone1: phone1,
            relation2: relation2,
            phone2: phone2
        }

        fetchPost(API.ADD_AFFECTION, {
            jsonAlbum: JSON.stringify(paramObj)
        }).then(response => {
            Toast.hide()
            this.backTask = setTimeout(() => {
                this.props.history.goBack();
            }, 1000)
        }).catch(error => {
            Toast.hide()

            if (typeof error === 'string') {
                Toast.fail(error, 2)
            } else {
                Toast.fail('保存失败')
            }
        })
    }

    nicknameValueCom = (event)=>{
        //获取用户名的值
        let relation = this.refs.relation.value;
        let phone = this.refs.phone.value;
        let relation1 = this.refs.relation1.value;
        let phone1 = this.refs.phone1.value;
        let relation2 = this.refs.relation2.value;
        let phone2 = this.refs.phone2.value;
        //获得内容的值
        this.setState({
            relation:relation,
            phone:phone,
            relation1:relation1,
            phone1:phone1,
            relation2:relation2,
            phone2:phone2,
        })
    }

    getAffection= () => {
      Toast.loading('', 0);
      const {IMEI} = this.state;
      fetchGet(API.AFFECTION_LIST, {
          IMEI: IMEI,
      }).then(response => {
          Toast.hide();

        if (response && response.data ) {
            this.setState({
                  relation:response.data.contacts,
                  phone:response.data.phone,
                  relation1:response.data.contacts1,
                  phone1:response.data.phone1,
                  relation2:response.data.contacts2,
                  phone2:response.data.phone2,
                }, () => {
                  console.log(response.data)
                })
          }

      }).catch(error => {
          Toast.hide();

          if (typeof error === 'string') {
              Toast.fail(error, 2)
          } else {
              Toast.fail('请求异常', 2)
          }
      })
  };

}

export  default AffectionPhone;